/// ZENDESK INTEGRATION APP ///
/// by RV ///

/* globals $ */
if (typeof jQuery == 'undefined') {
  var script = document.createElement('script');
  script.src = 'https://code.jquery.com/jquery-3.6.0.min.js';
  script.type = 'text/javascript';
  document.getElementsByTagName('head')[0].appendChild(script);
} else {
  console.log('zendesk Jquery not loaded..!!');
}


var appstore = setInterval(function(){

$(document).ready(function () {
  const api_url = 'https://flolab.zendesk.com/api/v2'
  const api_key = '20rvhM5d718qGga7pyyXDyNcDXy85LQs1HdlP0oZ'
  const fields = [
    {
      id: '360033896734',
      name: 'Issue Type'
    },
    {
      id: '360034249813',
      name: 'Replacment Reason'
    },
    {
      id: '360034325654',
      name: 'Order Number'
    }
  ]

  // activate file upload


  $("input#zd-form-file-data,  file_section .file_button").on('change',(evt)=>{
    $(".file_section .file-name").text(evt.target.files[0].name)
  })

  $('#zd-form-file-upload , .file_section .file_button').on('click', (evt) => {
    evt.preventDefault()
    $('#zd-form-file-data').click()
  })

  // watch form submit
  $('#zd-form-submit').on('click', () => {
    $('#zd-form-submit').html('Please wait...')
    submitForm()
  })

  // submit form
  function submitForm () {
    const form_data = $('#zd_contact_form').serializeArray()
    const file = getFile()

    const data = {
      name: findFieldValue(form_data, 'zd-form-name'),
      email: findFieldValue(form_data, 'zd-form-email'),
      subject: findFieldValue(form_data, 'zd-form-subject') || 'Customer Contact',
      body: findFieldValue(form_data, 'zd-form-body') || '',
      issue_type: findFieldValue(form_data, 'zd-form-type') || 'other',
      replacement_reason: findFieldValue(form_data, 'zd-form-replacement-reason'),
      order_number: findFieldValue(form_data, 'zd-form-order-number')
    }

    if (file) {
      uploadAttachments(data, file)
    } else {
      submitRequest(data)
    }
  }

  function getFile () {
    const files = $('#zd-form-file-data').prop('files')
    if (files) {
      return files[0]
    } else {
      return null
    }
  }

  function findFieldValue (fieldArray, fieldName) {
    const field = fieldArray.find(field => field.name === fieldName)
    if (field) {
      return field.value
    } else {
      return null
    }
  }

  function uploadAttachments (request, file) {
    $.ajax({
      type: 'POST',
      url: `${api_url}/uploads.json?filename=${file.name}`,
      data: file,
      processData: false,
      contentType: false,
      enctype: 'multipart/form-data',
      cache: false,
      success: data => {
        const uploads = [JSON.parse(data).upload.token]
        submitRequest(request, uploads)
      }
    })
  }
  
  function submitRequest (data, uploads) {
    let request_data = {
      request: {
        requester: {
          name: data.name,
          email: data.email
        },
        subject: data.subject,
        comment: {
          body: data.body,
          uploads: uploads
        },
        custom_fields: [
          {
            id: fields[0].id,
            value: data.issue_type
          },
          {
            id: fields[1].id,
            value: data.replacement_reason
          },
          {
            id: fields[2].id,
            value: data.order_number
          }
        ]
      }
    }

    $.ajax({
      type: 'POST',
      url: `${api_url}/requests.json`,
      dataType: 'json',
      data: JSON.stringify(request_data),
      contentType: 'application/json',
      success: data => {
        submitSuccess()
      }
    })
  }

  function submitSuccess () {
    $('#zd_contact_form')[0].reset()
    $('#zd-form-submit').html('Submit')
    $('#zd-form-file-data').val(null)
    $('.success-quote').show()
  }
})

if (typeof jQuery == 'undefined') {
  var script = document.createElement('script');
  script.src = 'https://code.jquery.com/jquery-3.6.0.min.js';
  script.type = 'text/javascript';
  document.getElementsByTagName('head')[0].appendChild(script);
} else {
  clearInterval(appstore);
}
}, 3000);